<style lang="less" scoped>
  .container{
    position: relative;
      /deep/ .row {
        margin:auto;
      }
  }
  .m-f {
    display: flex;
  }
   .title-s {
        
        font-weight: bold;
      }
  .f-1 {
    margin: 0 5px;
    flex: 1;
    .content {
     
      .label {
        display:inline-block;
        width:50%;
      }
      .value {
         display:inline-block;
        width:50%
      }
    }
  }
  
</style>
<template>
  <div class="container">
    <div v-if="!loading && expense_group.id">
      <div class="m-f">
        <div class="f-1">
          <VTableCard 
           
            :value="expense_group"
            :fields="fk_fields"
          >
            <template v-slot:title>
              <v-ripple-col
                :md="12"
                cols="12"
              >
                <span style="white-space:nowrap;font-weight: bold;">付款信息</span>
              </v-ripple-col>
            </template>
          </VTableCard>
        </div>
        <div class="f-1">
          <VTableCard 
            :value="expense_group"
            :fields="zh_fields"
          >
            <template v-slot:title>
              <v-ripple-col
                :md="12"
                cols="12"
              >
                <span style="white-space:nowrap;font-weight: bold;">账户信息</span>
              </v-ripple-col>
            </template>
          </VTableCard>
        </div>
        <div
          v-if="expense_group.invoice_info || is_type_8"
          class="f-1"
        >
          <VTableCard 
         
            :value="expense_group.invoice_info || {}"
            :fields="fp_fields"
          >
            <template v-slot:title>
              <v-ripple-col
                :md="12"
                cols="12"
              >
                <span style="white-space:nowrap;font-weight: bold;">发票信息</span>
              </v-ripple-col>
            </template>
          </VTableCard>
        </div>
      </div>


      <div
      
        class="line"
      >
        <Button
          v-if="type === 1"
          icon="md-link"
          size="small"
          @click="showLinkAssetModal"
        >
          关联固定资产
        </Button>
        <Button
          v-if="[1,9].includes(type)"
          icon="md-link"
          size="small"
          style="margin:0px 10px"
          @click="showPutInModal"
        >
          关联投放计划
        </Button>
        <Button
          v-if="1===type"
          icon="ios-cloud-download"
          size="small"
          style="margin:0px 10px"
          @click="exportTfRecords"
        >
          导出投放记录
        </Button>
        <!-- expense_group_export_placing_records_payee_info -->
        <v-divider />
      </div>
      <div v-if="has_reimbursement">
        <ReimbursementInfo :reimbursement="reimbursement" />
      </div>

      <v-divider />

      <div
        v-if="expenses.length"
        class="text-center"
      >
        <Table
          size="small"
          :columns="expense_columns"
          :data="expenses"
        />
      </div>
      <div
        v-if="expense_group.advance.id"
        class="line"
      >
        <div class="line">
          <span class="text-bold">关联预支单: </span>
          <ViewerItem
            :model_id="expense_group.advance.id"
            type="ExpenseGroup"
          >
            <span class="link">{{ expense_group.advance.uid }}</span>
          </ViewerItem>
          <span> - {{ expense_group.advance.name }}</span>
          <span> - 预支金额: ￥{{ formatPrice(expense_group.advance.total_price) }}</span>
          <span> - 预支时间: {{ expense_group.advance.paid_at }}</span>
        </div>
        <div class="line">
          <span>用途: {{ expense_group.advance.purpose }}</span>
        </div>
      </div>
      <div v-if="is_type_8">
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              发票附件：
            </v-expansion-panel-header>
            <v-expansion-panel-content v-if="expense_group.expense_register.invoices">
              <div
                v-for="invoice in expense_group.expense_register.invoices" 
                :key="invoice.id"
              >
                <div
                  v-if="invoice.invoice_info"
                  style="display: flex;align-items: center;"
                >
                  <ImagePreview  
                    :src="invoice.file"
                    :width="300"
                  />
                  <div style="margin-left: 20px;">
                    <div>发票代码：{{ invoice.invoice_info.code }}</div>
                    <div>发票号码：{{ invoice.invoice_info.uid }}</div>
                    <div>发票类型：{{ getInvoiceType(invoice.invoice_info.invoice_type) }}</div>
                    <div>发票OCR类型：{{ getInvoiceOCRType(invoice.invoice_info.ocr_invoice_type) }}</div>
                    <div>发票金额：{{ invoice.invoice_info.total_price }}</div>
                    <div>税率：{{ invoice.invoice_info.tax_rate }}</div>
                    <div>开票方：{{ invoice.invoice_info.seller }}</div>
                    <div>购买方：{{ invoice.invoice_info.buyer }}</div>
                  </div>
                  <div>
                    <Button @click="$refs.editor.edit(invoice.invoice_info)">
                      编辑
                    </Button>
                    <Button
                      style="margin-left: 20px;"
                      @click="delInvoice(invoice.id)"
                    >
                      删除
                    </Button>
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <div
        v-if="expense_group.bfiles.length"
        class="line"
      >
        附件:
        <Attachments :files="expense_group.bfiles" />
      </div>
      <div
        v-else
        class="line"
      >
        <Alert type="warning">
          <Icon type="ios-paper-outline" />
          没有添加附件
        </Alert>
      </div>
      <div
        v-if="expense_group.desc"
        class="line"
      >
        <div class="line text-bold">
          <span>备注: </span>
        </div>
        <div v-html="expense_group.desc" />
      </div>
      <div
        v-if="expense_group.contract&&expense_group.contract.id"
        class="line"
      >
        <div class="hr" />
        <div>
          关联合同:
          <ViewerItem
            :model_id="expense_group.contract.id"
            type="Contract"
          >
            <span class="link">{{ expense_group.contract.uid }}</span>
          </ViewerItem>,
          合同名称: <span class="text-bold">{{ expense_group.contract.name }}</span>
          <span v-if="is_financer">，账单生成方式	: <span class="text-bold">{{ bill_generate_type }}</span></span>
          <span
            v-if="expense_group.contract&&expense_group.contract.need_related_placing"
            class="text-bold"
          >，【未关联投放记录】</span>
          <span
            v-if="expense_group.outsource_contract&&expense_group.outsource_contract.need_related_placing"
            class="text-bold"
          >，【未关联投放记录】</span>
        </div>
        <div>
          申请人: <span class="text-bold">{{ expense_group.contract.apply_user }}</span>,
          对方公司: <span class="text-bold">{{ expense_group.contract.payee_company || '-' }}</span>
        </div>
      </div>
      <div v-if="expense_group.from_expense_group">
        <div class="hr" />
        转换来源：
        <div>
          单据编号：
          <ViewerItem
            :model_id="expense_group.from_expense_group.id"
            type="ExpenseGroup"
          >
            <span class="link">{{ expense_group.from_expense_group.uid }}</span>
          </ViewerItem>,
          单据名称： <span class="text-bold">{{ expense_group.from_expense_group.name }}</span>
        </div>
      </div>
      <div v-if="expense_group.to_expense_group">
        <div class="hr" />
        转换账单：
        <div>
          单据编号：
          <ViewerItem
            :model_id="expense_group.to_expense_group.id"
            type="ExpenseGroup"
          >
            <span class="link">{{ expense_group.to_expense_group.uid }}</span>
          </ViewerItem>,
          单据名称： <span class="text-bold">{{ expense_group.to_expense_group.name }}</span>
        </div>
      </div>
      <div
        v-if="expense_group.outsource_contract_id"
        class="line"
      >
        <div class="hr" />
        关联兼职外包合同:
        <ViewerItem
          :model_id="expense_group.outsource_contract.id"
          type="OutsourceContract"
        >
          <span class="link">{{ expense_group.outsource_contract.uid }}</span>
          <span> - {{ expense_group.outsource_contract.account }}</span>
        </ViewerItem>
      </div>
      <div
        v-if="expense_group.expense_group"
        class="line"
      >
        <div class="hr" />
        关联报销单:
        <ViewerItem
          :model_id="expense_group.expense_group.id"
          type="ExpenseGroup"
        >
          <span class="link">{{ expense_group.expense_group.uid }}</span>
          <span> - {{ expense_group.expense_group.name }}</span>
        </ViewerItem>
      </div>
      <div
        v-if="expense_group.refund_expense_group"
        class="line"
      >
        <div class="hr" />
        关联退款单:
        <ViewerItem
          :model_id="expense_group.refund_expense_group.id"
          type="ExpenseGroup"
        >
          <span class="link">{{ expense_group.refund_expense_group.uid }}</span>
          <span> - {{ expense_group.refund_expense_group.name }}</span>
        </ViewerItem>
      </div>
      <div
        v-if="expense_group.returned_expense_group"
        class="line"
      >
        <div class="hr" />
        关联原始单据:
        <ViewerItem
          :model_id="expense_group.returned_expense_group.id"
          type="ExpenseGroup"
        >
          <span class="link">{{ expense_group.returned_expense_group.uid }}</span>
          <span> - {{ expense_group.returned_expense_group.name }}</span>
        </ViewerItem>
      </div>
      <div class="hr" />
      <div
        v-if="expense_group.user_flow"
        class="line"
      >
        <UserFlow :user_flow="expense_group.user_flow" />
      </div>
    </div>
    <linkAssetModal
      ref="link_asset_modal"
      :linked_assets="linked_assets"
      :expenses="expenses"
      @getDetail="getDetail"
    />
    <PutInModal 
      ref="put_in_modal"
      :tf-max="40"
      :bill-type="type"
      :is-financer="is_financer"
      :is-check-same-bill="type===1"
      :expense-group="expense_group"
      :have-paid-amountitle-total="type===1?'本次付款金额总计：':'本次账单金额总计：'"
    />
    <Spin
      v-if="loading"
      fix
    />
    <Editor
      ref="editor"
      class="mx-2"
      type="primary"
      @on-change="afterChange"
    />
  </div>
</template>
<script>
  import { getsafe } from '@/libs/util.js'
  import VTableCard from '@/vuetify_custom/v-table-card'
  import ExpenseGroupUtil from '../../expense_group/libs/util';
  import ExpenseUtil from '../../../libs/expense_util';
  import InvoiceUtil from '../../invoice/libs/util';
  import OSUtil from '../../outsource/libs/outsource_util';
  import VRippleCol from '../../../vuetify_custom/v-ripple-col';
  import ReimbursementInfo from '../../expense_group/components/reimbursement_info';
  import ExpenseExpand from './expense_expand';
  import PaymentStatus from '../../expense_payment_record/components/status';
  import ViewerItem from '../../components/viewer/item';
  import Attachments from '../../components/file/attachments';
  import InvoicePicker from '../../invoice/components/invoice_picker';
  import linkAssetModal from './link_asset_modal'
  import PutInModal from './PutInModal.jsx'
  import {mapGetters} from "vuex";
  import moment from 'moment';
  import Editor from '../../invoice/components/invoice_editor';
  import ImagePreview from '../../components/image/image_preview';
  const bill_generate_type_hash = {
    no_need: '无需提供账单',
    self_submit: '业务提供账单',
    expense_group: '付款生成账单'
  }
  export default {
    components: { 'v-ripple-col': VRippleCol, ReimbursementInfo, ExpenseExpand, PaymentStatus,
                  ViewerItem, Attachments, InvoicePicker, linkAssetModal, PutInModal, VTableCard, ImagePreview, Editor},
    props: {
      type: {
        type: Number
      },
      model_id: {
        type: Number,
        required: true
      },
      canEdit: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        linked_assets: [],
        loading: false,
        expense_group: {},
        show_asset_id: 0,
        stocks_hash: {},
        contract_stock_columns:[
          {
            title: '存货编码',
            key: 'uid',
            render: (h, params) => {
              return h('div', this.stocks_hash[params.row.stock_id].uid)
            }
          },
          {
            title: '存货名称',
            key: 'name',
            render: (h, params) => {
              return h('div', this.stocks_hash[params.row.stock_id].name)
            }
          },
          {
            title: '采购数量',
            key: 'qty'
          },
          {
            title: '采购单价',
            key: 'unit_price'
          },
          {
            title: '总价',
            key: 'total_price'
          }
        ],
        edit_expense: {
          expense_invoices: []
        },
        new_expense_invoice: {
          link_model_id: 0,
          link_model_type: 'Expense',
          uid: '',
          invoice_type: -1,
          price: 0.00,
          desc: ''
        },
        invoice_removing: false
      }
    },
    computed: {
      is_type_8() {
        return this.type === 8
      },
      fk_fields() {
        const arr = [
          {
            key: 'title'
          },
          {
            label: '入账会计期:',
            key: 'verified_at',
            valueRender: ({value}) => {
              return value.verified_at ? moment(value.verified_at).format('YYYY-MM-DD') : '-'
            }
          },
          {
            label: '付款日期:',
            key: 'paid_at',
            valueRender: ({value}) => {
              return value.paid_at ? moment(value.paid_at).format('YYYY-MM-DD') : '-'
            }
          },
          {
            label: '币别：',
            key: 'currency',
            valueRender: () => {
              return this.getCurrencyLabel(this.expense_group.currency)
            }
          },
          {
            label: '原币金额:',
            key: 'total_price',
            type: 'money_field'
          },
          {
            label: '本位币金额:',
            key: 'cny_total_price',
            type: 'money_field'
          },
          {
            label: '付款状态:',
            key: 'fk_status',
            render: ({h, target}) => {
              return h(PaymentStatus, {
                props: {
                  expenseGroupId: target.id,
                }
              })
            }
          
          },
          {
            label: '实际交付内容:',
            key: 'purpose',
            default_value: '-'
          },
          {
            label: '摘要:',
            key: 'cbs_remark',
            default_value: '-'
          },
          {
            label: '是否需要付款:',
            key: 'for_new_payment',
            type: 'bool_field',
            default_value: '-',
            types_in: [8]
          },
          {
            label: '账户核验',
            key: 'three_check_status',
       
            default_value: '-',
            valueRender:() => {
              return this.$util.threeCheckStatusName(this.expense_group.three_check_status) 
            }
          },
       
        ]
        return arr.filter(i => {
          if (!i.types_in) {
            return true
          }
          return i.types_in.includes(this.type)
        })
      },
      zh_fields() {
        const arr = [
          {
            key: 'title'
          },
          {
            label: '我方银行:',
            key: 'payment_bank_name'
          },
          {
            label: '我方账户:',
            key: 'payment_bank_account'
          },
          {
            label: '我方卡号:',
            key: 'payment_bank_number'
          },
          {
            label: '对方银行:',
            key: 'payee_bank'
          },
          {
            label: '对方账户:',
            key: 'payee_account_name'
          },
          {
            label: '对方卡号:',
            key: 'payee_bank_number'
          },
       
        ]
        return arr.filter(i => {
          if (!i.types_in) {
            return true
          }
          return i.types_in.includes(this.type)
        })
      },
      fp_fields() {
        const arr = [
          {
            key: 'title'
          },
          {
            label: '合规发票金额:',
            key: 'valid_invoice_price',
            type: 'money_field'
          },
          {
            label: '无发票金额:',
            key: 'none_invoice_price',
            type: 'money_field'
          },
          {
            label: '发票号码：',
            key: 'nothing',
            valueRender:() => {
              return this.invoices_uids.map(i => i.uid).join('、') 
            },
            types_in: [8]
          },
          {
            label: '发票提交地点：',
            key: 'nothing_1',
            valueRender:() => {
              return this.location
            },
            types_in: [8]

          },
          {
            // 发票提交方式
            label: '发票提交方式：',
            key: 'nothing_2',
            valueRender:() => {
              const invoices_uids = getsafe(this, 'invoices_uids', [])
              return invoices_uids.length ? '自主提交发票' : '财务代收发票'
            },
            types_in: [8]
          },
          {
            label: '是否已提供足额发票：',
            key: 'nothing_3',
            valueRender:() => {

              return getsafe(this.expense_group, 'invoice_info.invoice_valid') ? '是' : '否'
            },
            // expense_group.invoice_info.invoice_valid
          },
          {
            label: '企业需承担额外税额',
            key: 'nothing_4',
            valueRender:() => {
              const need = getsafe(this.expense_group, 'invoice_info.invoice_valid')
              const none_invoice_tax = getsafe(this.expense_group, 'invoice_info.none_invoice_tax')
            
              if (need || !none_invoice_tax || this.expense_group.payment_type !== 0) {
                return '-'
              }
              return this.formatPrice(none_invoice_tax)
            },
          },
        
        ]
        return arr.filter(i => {
          if (!i.types_in) {
            return true
          }
          return i.types_in.includes(this.type)
        })
      },
      invoices_uids() {
        const keys = ['expense_group', 'expense_register', 'invoices']
        return keys.reduce((t, k) => {
          t = t[k] || []
          return t
        }, this)
      },
      location() {
        const keys = ['expense_group', 'expense_register', 'submit_type']
        const l = keys.reduce((t, k) => {
          t = t[k] || []
          return t
        }, this)
      
        return Number(l) === 1 ? '财务投放点-C区5楼' : '财务投放点-E区14楼'
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      is_financer() {
        return this.cur_customer.groups && this.cur_customer.groups.includes('GROUP_FIN');
      },
      bill_generate_type() {
        const contract = (this.expense_group || {}).contract || {}
        return bill_generate_type_hash[contract.bill_generate_type]
      },
      has_reimbursement() {
        return this.expense_group && this.expense_group.reimbursement;
      },
      reimbursement() {
        return this.expense_group.reimbursement;
      },
      expenses() {
        const expenses = [];
        if (this.expense_group.expenses) {
          this.expense_group.expenses.forEach((expense) => {
            if (this.canEdit) {
              expense._expanded = true;
            }
            expenses.push(expense);
          });
        }
        return expenses;
      },
      is_advance_or_recharge() {
        return [2, 3].indexOf(this.expense_group.payment_type) > -1;
      },
      ...mapGetters({
        companies_hash: 'async/companies_hash',
        teams_hash: 'async/root_teams_hash',
        expense_types_hash: 'async/expense_types_hash',
        offices_hash: 'async/offices_hash',
        account_leaf_titles_hash: 'async/account_leaf_titles_hash',
        analysis_leaf_titles_hash: 'async/analysis_leaf_titles_hash',
        expense_natures_hash: 'async/expense_natures_hash',
        mapping_customer_types_hash: 'async/mapping_customer_types_hash',
        item_types_hash: 'async/item_types_hash',
        fund_usages_hash: 'async/fund_usages_hash',
        customer_functions_hash: 'async/customer_functions_hash'
      }),
      expense_columns() {
        let ret = [
          {
            title: '展开',
            type: 'expand',
            align: 'center',
            width: 50,
            render: (h, params) => {
              return h(ExpenseExpand, {
                props: {
                  expense: params.row,
                  is_advance_or_recharge: this.is_advance_or_recharge
                }
              })
            }
          },
          {
            title: '项目描述',
            key: 'name',
            render: (h, params) => {
              const row = params.row;
              const ret = [
                h('div', row.name)
              ];
              if (row.contract_uid) {
                ret.push(h('div', `合同:${row.contract_uid}`));
              }
              return h('div', ret);
            }
          },
        ];
        ret = ret.concat([
          {
            title: '付款金额',
            align: 'right',
            key: 'price',
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatPrice(row.price));
            }
          },
          {
            title: '付款手续费',
            align: 'right',
            width: 110,
            key: 'service_fee',
            includes_types: [1, 9],
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              if (row.service_fee) {
                ret.push(h('div', this.$util.formatPrice(row.service_fee)))
              } else {
                ret.push(h('div', '-'))
              } 
              return h('div', {
                'class': {
                  'text-right': true
                }
              }, ret);
            }
          },
          {
            title: '预估税率(%)',
            align: 'right',
            key: 'tax_rate',
            render: (h, params) => {
              const row = params.row;
              return h('span', isNaN(row.tax_rate) ? '-' : (row.tax_rate * 100).toFixed(2));
            }
          },
          // {
          //   title: '费用类别',
          //   align: 'center',
          //   key: 'expense_type_id',
          //   render: (h, params) => {
          //     const type = this.expense_types_hash[params.row.expense_type_id];
          //     return h('div', type ? type.full_name : '未设置');
          //   }
          // },
          {
            title: '科目映射',
            align: 'center',
            key: 'kemuyingshe',
            width: 210,
            render: (h, params) => {
              const expense_natures_name = getsafe(getsafe(this.expense_natures_hash, `${params.row.expense_nature_id}`), 'name')
              const customer_functions_name = getsafe(getsafe(this.customer_functions_hash, `${params.row.customer_function_id}`), 'name')
              const customer_types_name = getsafe(getsafe(this.mapping_customer_types_hash, `${params.row.customer_type}`), 'label')
              const fund_usage_name = getsafe(getsafe(this.fund_usages_hash, `${params.row.fund_usage_id}`), 'name')
              const item_type_name = getsafe(getsafe(this.item_types_hash, `${params.row.item_type_id}`), 'name')
              const is_insider_trading = getsafe(params, 'row.is_insider_trading')
              let arr = [
                {
                  label: '费用nature：',
                  value: expense_natures_name || undefined,
                },
                {
                  label: '人员属性：',
                  value: customer_types_name || undefined,
                },
                {
                  label: '职能：',
                  value: customer_functions_name || undefined,
                },
                {
                  label: '费用用途：',
                  value: fund_usage_name || undefined,
                },
                {
                  label: '产品类型：',
                  value: item_type_name || undefined,
                },
                {
                  label: '内部交易：',
                  value:[true, false].includes(is_insider_trading) ? is_insider_trading ? '是' : '否' : undefined,
                },
                
              ]
              arr = arr.filter(i => i.value !== undefined)
              arr = arr.map(i => h('div', `${i.label}${i.value}`))
              return h('div', arr);
            }
          },
          {
            title: '科目',
            align: 'center',
            key: 'account_title_id',
            width: 210,
            render: (h, params) => {
              const account_title_type = getsafe(getsafe(this.account_leaf_titles_hash, `${params.row.account_title_id}`), 'full_name', '-')
              const analysis_title_type = getsafe(getsafe(this.analysis_leaf_titles_hash, `${params.row.analysis_title_id}`), 'full_name', '-')
              return h('div', [h('div', `会计科目：${account_title_type}`), h('div', `分析科目：${analysis_title_type}`)]);
            }
          },
       
          /*  {
            title: '预估发票信息',
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', `类型: ${InvoiceUtil.getInvoiceType(row.invoice_type)}`));
              if (row.invoice_type === 1) {
                ret.push(h('div', `税率: ${InvoiceUtil.getTaxRate(row.tax_rate)}`));
                ret.push(h('div', `税额: ${this.$util.formatPrice(row.tax)}`));
              }
              return h('div', ret);
            }
          }, */
          {
            title: '备注',
            key: 'desc',
            align: 'center',
          }
        ]);
        if (this.canEdit && !this.is_advance_or_recharge) {
          ret.push({
            title: '操作',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h(InvoicePicker, {
                props: {
                  size: 'small',
                  model_type: 'Expense',
                  model_id: row.id,
                  invoices: row.invoices,
                  reimbursement: this.reimbursement
                },
                on: {
                  'update:invoices': (invoices) => {
                    row.invoices = invoices;
                  },
                },
              });
            }
          });
        }
        return ret.filter(i => {
          if (i.includes_types) {
            return i.includes_types.includes(this.type)
          }
          return true
        });
      }
    },
    created() {
      this.getDetail();
    },
    mounted() {

      //
    },
    methods: {
      delInvoice(id) {
        this.$Modal.confirm({
          title: '提示',
          content: '你确定要删除吗?',
          onOk: () => {
            ExpenseGroupUtil.deleteInvoice(id).then(
              res => {
                console.log(res)
              }
            ).finally(
              () => {
                this.getDetail()
              }
            )
          }
        })
      },
      getInvoiceType: InvoiceUtil.getInvoiceType,
      getInvoiceOCRType: InvoiceUtil.getInvoiceOCRType,
      getsafe(...arg) {
        return getsafe(...arg)
      },
      exportTfRecords() {
        window.open(`/api/${this.$util.api.expense_group_export_placing_records_payee_info}?id=${this.expense_group.id}`, '__blank')
        // 
      },
      showLinkAssetModal() {
        this.$refs.link_asset_modal.init()
      },
      // put_in_modal
      showPutInModal() {
        this.$refs.put_in_modal.init()
      },
      getDetail() {
        this.loading = true;
        ExpenseGroupUtil.getDetail(this.model_id).then((data) => {
          this.$set(this, 'expense_group', data.expense_group);
          if (this.expense_group && this.expense_group.expenses) {
            this.linked_assets = this.expense_group.expenses.reduce((acc, cur) => {
              acc = acc.concat(cur.asset_expense_teams.map(asset => {
                return Object.assign(asset, {
                  expense_type_id: cur.expense_type_id,
                  expense_id: cur.id,
                  expense_name: cur.name
                })
              }))
              return acc
            }, [])
          }
          //this.handleContractStocks();
        }).catch((e) => {
          console.log(e);
          this.$Message.error('获取数据失败, 请重试!');
        }).finally(() => {
          this.loading = false;
        });
      },
      checkInvoiceValid() {
        let err_msg = '';
        this.edit_expense.expense_invoices.forEach((invoice, index) => {
          if (invoice.invoice_type === -1) {
            err_msg += `<p>[发票${index + 1}] 请选择类型</p>`;
          }
          if (!invoice.uid.trim()) {
            err_msg += `<p>[发票${index + 1}] 请填写发票号</p>`;
          }
          if (!this.$util.isNumber(invoice.price)) {
            err_msg += `<p>[发票${index + 1}] 请填写正确的发票金额</p>`;
          }
        });
        if (err_msg) {
          this.$Modal.error({
            title: '提示',
            content: err_msg
          });
          this.resetInvoiceConfigLoading();
          return false;
        }
        return true;
      },
      getTeamName(team_id) {
        const team = this.teams_hash[team_id];
        return team ? team.name : '未定义团队';
      },
      getOSSettlementType(type) {
        return OSUtil.getSettlementType(type);
      },
      getCurrencyName(currency_value) {
        return ExpenseUtil.getCurrencyName(currency_value);
      },
      getCurrencyLabel(currency_value) {
        return ExpenseUtil.getCurrencyLabel(currency_value);
      },
      getCurrencySymbol(currency_value) {
        return ExpenseUtil.getCurrencySymbol(currency_value);
      },
      formatPrice(price) {
        return this.$util.formatPrice(price);
      },
      downloadAttachment(bfile) {
        return Util.downloadToBlank({
          id: bfile.id
        })
        
      },
      afterChange() {
        this.getDetail()
        this.$refs.editor.cancel()
      }
    }
  }
</script>
